<template>
  <div class="home" ref="RefdHome">
    <platHeader :showPlat="showPlat" />
    <router-view
      :style="{ minHeight: minHeight + 'px' }"
      style="min-width: 1280px"
    ></router-view>
    <div ref="RefFooter" class="footer">
      <div>
        <!-- <div>
          © 2021 百家在线数据集团有限公司 |
          <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">
            &nbsp;京ICP备19039670号-2
          </a>
        </div> -->
        <!-- <div>
          网络出版服务许可证：（总）网出证（京）字第202号 | <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">京ICP备19039670号-2</a> |
          ICP：京ICP证 140746号
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import platHeader from './components/header'
import { GetRequest } from '@/utils/utils'
export default {
  name: 'Home',
  components: {
    platHeader
  },
  data () {
    return {
      showPlat: true,
      path: '',
      minHeight: 0
    }
  },
  watch: {
    $route: {
      handler (to, form) {
        if (to.path !== '/' && to.path !== '/classify') {
          this.showPlat = false
        } else {
          this.showPlat = true
        }
      }
    }
  },
  methods: {
    isShowPlat () {
      this.path = this.$route.path
      if (this.path !== '/' && this.path !== '/classify') {
        this.showPlat = false
      }
    }
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight - 240
    var that = this
    window.onresize = function () {
      that.minHeight = document.documentElement.clientHeight - 240
    }
  },
  created () {
    this.isShowPlat()
  }
}
</script>

<style scoped lang="less">
.beian {
  color: #ffffff;
}
.beian:hover {
  color: #1a33c5;
}
.footer {
  height: 100px;
  background-color: #007fff;
  margin-top: 40px;
}
.footer {
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer > div div {
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
}
</style>
